import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, AlertController } from 'ionic-angular';

import { Project, Master, User } from '@providers/index';
import { ListProjectPage, LoginPage, ProfilePage } from '../index';

@Component({
  selector: 'page-dashboard-project',
  templateUrl: 'page.html'
})
export class DashboardPage {

  public barChartData:any[] = [
    {data: [0], label: ''},
    {data: [0], label: ''},
    {data: [0], label: ''},
    {data: [0], label: ''},
    {data: [0], label: ''},
  ];
  public barChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartType:string = 'bar';
  public barChartLegend:boolean = true;


  public doughnutChartLabels:string[] = ["OE < 1 Billions","OE = 1 - 5 Billions","OE =  5 - 25 Billions","OE > 25 Billions","Other"];
  public doughnutChartData:number[] = [0,0,0,0,0,0];
  public doughnutChartColor = [
      {
        backgroundColor : ["#fff","#f4f4f5","#cdebfd","#b1dc99","#fbdb7a","#ef7596","#f4f4f5"]
      }
  ];
  public doughnutChartType:string = 'doughnut';
  
  user:any = {};

  projectStat:any = [];
  projectByRate:any = [];
  dataBar:any = [];
  listPerDepartment:any=[];
  AllDepartment=0;

  company:any = [];
  branch:any = [];
  sbu:any = [];
  rate:any=[];
  company_all_selected:any = 1;
  branch_all_selected:any = 1;
  sbu_all_selected:any = 1;
  company_selected = [];
  branch_selected = [];
  sbu_selected = [];
  readyFilter = 0;

  status:any=[];
  status_selected = [];
  status_all_selected: any= 1;
  status_count =0;

  branch_user = false;
  sbu_user    = false;
  custom_user = false;
  dept_user   = false;

  company_ids = [];
  branch_ids  = [];
  sbu_ids     = [];
  dept_ids    = [];

  global:any=[];
  project:any=[];

  constructor(
    public navCtrl     : NavController,
    public toastCtrl   : ToastController,
    public loadingCtrl : LoadingController,
    public alertCtrl   : AlertController,
    public masterApi   : Master,
    public userApi     : User,
    public projectApi  : Project
  ) {
    if(this.userApi.akses.lihat_project_group_data=='branch'){
      this.branch_user = true;
    }
    if(this.userApi.akses.lihat_project_group_data=='sbu'){
      this.sbu_user = true;
    }
    if(this.userApi.akses.lihat_project_group_data == 'dept'){
      this.dept_user = true;
    }
    if(this.userApi.akses.lihat_project_group_data=='fitur_user_data'){
      this.custom_user = true;
      if(!this.userApi.akses.lihat_project_user_data.all_company){
        this.company_ids = this.userApi.akses.lihat_project_user_data.company_ids.split(",");
        console.log('akses custom company_ids => ', this.company_ids);
      }
      if(!this.userApi.akses.lihat_project_user_data.all_branch){
        this.branch_ids = this.userApi.akses.lihat_project_user_data.branch_ids.split(",");
        console.log('akses custom branch_ids => ', this.branch_ids);
      }
      if(!this.userApi.akses.lihat_project_user_data.all_sbu){
        this.sbu_ids = this.userApi.akses.lihat_project_user_data.sbu_ids.split(",");
        console.log('akses custom sbu_ids => ', this.sbu_ids);
      }
      if(!this.userApi.akses.lihat_project_user_data.all_dept){
        this.dept_ids = this.userApi.akses.lihat_project_user_data.dept_ids.split(",");
        console.log('akses custom dept_ids => ', this.dept_ids);
      }
    }

    this.getCompany();
    this.getBranch();
    this.getSBU();
    this.getRate();
    this.getStatus();
    this.getLanguage();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getDataProjectStat();
  }

  ionViewWillEnter() {
    if(this.userApi.akses.lihat_project_group_data=='mine'){

      this.navCtrl.push(ListProjectPage, {
        params : {}
      });

    }
  }

  getLanguage(){
    this.masterApi.language().subscribe((resp:any) => {
      this.global = resp.global;
      this.project = resp.project;
      this.masterApi.lang = resp;

      //this.lang = this.masterApi.lang;
    });
  }

  ionViewDidEnter() {
    this.getDataProjectStat();
  }

  public getCompany(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.company(params).subscribe((resp:any) => {
      console.log("company data => ", resp.data);
      resp.data.forEach(rec => {
        if(this.sbu_user || this.branch_user || this.dept_user){
          if(this.userApi.data.company_id==rec.id){
            rec.selected = 1;
            this.company_selected.push(rec.id);
          }
        }else if(this.custom_user){
          if(this.userApi.akses.lihat_project_user_data.all_company){
            rec.selected = 1;
            this.company_selected.push(rec.id);
          }else{
            this.company_ids.forEach(comp => {
              if(comp == rec.id){
                rec.selected = 1;
                this.company_selected.push(rec.id);
              }
            });
          }
        }else{
          rec.selected = 1;
          this.company_selected.push(rec.id);
        }
      });
      this.readyFilter++;
      if(this.readyFilter>=5){
        this.changeFilter();
      }
      this.company = resp.data;
      
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }
  
  public getBranch(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.branch(params).subscribe((resp:any) => {
      resp.data.forEach(rec => {
        if(this.branch_user){
          if(this.userApi.data.hrm_company_office_id==rec.id){
            this.branch.push(rec);
            rec.selected = 1;
            this.branch_selected.push(rec.id);
          }
        }else if(this.custom_user){
          if(this.userApi.akses.lihat_project_user_data.all_branch){
            this.branch = resp.data;
            rec.selected = 1;
            this.branch_selected.push(rec.id);
          }else{
            this.branch_ids.forEach(branch => {
              if(branch == rec.id){
                this.branch.push(rec);
                rec.selected = 1;
                this.branch_selected.push(rec.id);
              }
            });
          }
        }else{
          this.branch = resp.data;
          rec.selected = 1;
          this.branch_selected.push(rec.id);
        }
      });
      this.readyFilter++;
      if(this.readyFilter>=5){
        this.changeFilter();
      }
      // this.branch = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  public getSBU(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.sbu(params).subscribe((resp:any) => {
      resp.data.forEach(rec => {
        if(this.sbu_user){
          if(this.userApi.data.division_id==rec.id){
            this.sbu.push(rec);
            rec.selected = 1;
            this.sbu_selected.push(rec.id);
          }
        }else if(this.custom_user){
          if(this.userApi.akses.lihat_project_user_data.all_sbu){
            this.sbu = resp.data;
            rec.selected = 1;
            this.sbu_selected.push(rec.id);
          }else{
            this.sbu_ids.forEach(sbu => {
              if(sbu == rec.id){
                this.sbu.push(rec);
                rec.selected = 1;
                this.sbu_selected.push(rec.id);
              }
            });
          }
        }else{
          this.sbu = resp.data;
          rec.selected = 1;
          this.sbu_selected.push(rec.id);
        }
      });
      this.readyFilter++;
      if(this.readyFilter>=5){
        this.changeFilter();
      }
      // this.sbu = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  public getRate(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.rate(params).subscribe((resp:any) => {
      this.rate = resp.data;
      this.readyFilter++;
      if(this.readyFilter>=5){
        this.changeFilter();
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  public getStatus(){
    let params = {};
    this.masterApi.status(params).subscribe((resp:any) => {
      resp.data.forEach(rec => {
        rec.selected = 1;
        this.status_selected.push(rec.code);
      });
      this.readyFilter++;
      if(this.readyFilter>=5){
        this.changeFilter();
      }
      this.status       = resp.data;
      this.status_count = resp.data.length;
      console.log("status count => ", this.status_count);
      console.log(this.status_selected);
    }, (err) => {

    });
  }
  
  public getDataProjectStat(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.projectApi.getProjectStat(params).subscribe((resp:any) => {
      resp.data_by_rate.forEach(rec => {
        if(this.dept_user){
          if(this.userApi.data.department_id == rec.dept_id){
            this.projectStat.push(rec);
          }
        }else if(this.custom_user){
          if(this.userApi.akses.lihat_project_user_data.all_dept){
            this.projectStat.push(rec);
          }else{
            this.dept_ids.forEach(dept => {
              if(dept == rec.dept_id){
                this.projectStat.push(rec);
              }
            });
          }
        }else{
          this.projectStat.push(rec);
        }
      });
      console.log("resp getProjectStat => ", resp);
      this.projectStat = resp.data_by_rate;
      this.readyFilter++;
      if(this.readyFilter>=5){
        this.changeFilter();
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  filterBar(){
    this.dataBar =[];
    this.dataBar['all']=0;
      this.projectStat.forEach(rec1 => {
      let andCompany = this.company_selected.indexOf(rec1.company_id);
      let andBranch  = this.branch_selected.indexOf(rec1.branch_id);
      let andSbu     = this.sbu_selected.indexOf(rec1.sbu_id);
      let andStatus  = this.status_selected.indexOf(rec1.status);
      if(andCompany!=-1 && andBranch!=-1 && andSbu!=-1 && andStatus!=-1){
        if(this.dataBar[rec1.ratings]==undefined){
            this.dataBar[rec1.ratings] = 0;
        }
        this.dataBar[rec1.ratings] += parseInt(rec1.project_count); 
      }
    });
    this.barChartData = [];
    this.rate.forEach(rateRow => {
      let jml = 0;
      if(this.dataBar[rateRow.id]){
        jml = parseInt(this.dataBar[rateRow.id]);
        this.barChartData.push({data: [jml], label: rateRow.rate});
      }else{
        this.barChartData.push({data: [jml], label: rateRow.rate});
      }
      this.dataBar['all'] += jml;
    });
    this.barChartData.push({data: [this.dataBar['all']], label: 'All'});
  }

  filterDepartment(){
    let tempIndex = [];
    this.listPerDepartment = [];
    let i =0;
    this.AllDepartment = 0;
    let tempProjectStat = this.projectStat;
    tempProjectStat.forEach( rec2 => {
      let andCompany = this.company_selected.indexOf(rec2.company_id);
      let andBranch  = this.branch_selected.indexOf(rec2.branch_id);
      let andSbu     = this.sbu_selected.indexOf(rec2.sbu_id);
      let andStatus  = this.status_selected.indexOf(rec2.status);
      if(andCompany!=-1 && andBranch!=-1 && andSbu!=-1 && andStatus!=-1){
        if(tempIndex[rec2.dept_id]==undefined){
          let temp = {
            project_count  : parseInt(rec2.project_count),
            branch_name    : rec2.branch_name,
            sbu_short_name : rec2.sbu_name,
            dept_id        : rec2.dept_id,
            dept_short_name: rec2.dept_name,
            proj_status    : rec2.status
          }
          tempIndex[rec2.dept_id]=i;
          i++;
          this.listPerDepartment.push(temp);
        }
        else{
          this.listPerDepartment[ tempIndex[rec2.dept_id] ].project_count += parseInt(rec2.project_count);
        }
        this.AllDepartment += parseInt(rec2.project_count); 
        
      }

    });
  }

  filterPie(){
    let data = [];
    let label = [];
    
    this.projectByRate.forEach( rec2 => {
      let andCompany = this.company_selected.indexOf(rec2.company_id);
      let andSbu = this.sbu_selected.indexOf(rec2.sbu_id);
      let andBranch = this.branch_selected.indexOf(rec2.branch_id);
      if(rec2.rate==null){
        rec2.rate = 'Other';
      }
      if(andCompany!=-1 && andBranch!=-1 && andSbu!=-1){
        let i = label.indexOf(rec2.rate)
        if(i==-1){
          label.push(rec2.rate);
          data.push(rec2.project_count);
        }
        else{
          data[ i ] = parseInt(data[i]) + parseInt(rec2.project_count);
        }
      }

    });
    if(data.length==0){
      data = [0];
    }

    this.doughnutChartData = data;
    this.doughnutChartLabels = label;
    
  }

  public companyClick(i){
    if(this.sbu_user || this.branch_user || this.custom_user && !this.userApi.akses.lihat_project_user_data.all_company){
      return;
    }
    this.company[i].selected = !this.company[i].selected;
    this.changeFilter('company');
  }

  public companyClickAll(){
    if(this.sbu_user || this.branch_user || this.custom_user && !this.userApi.akses.lihat_project_user_data.all_company){
      return;
    }
    this.company_all_selected = !this.company_all_selected;
    this.company.forEach(rec => {
      rec.selected = this.company_all_selected;
    });
    this.changeFilter('company');
  }

  public branchClick(i){
    // if(this.sbu_user || this.branch_user || this.custom_user && !this.userApi.akses.lihat_project_user_data.all_branch){
    //   return;
    // }
    if(this.branch_user){
      return;
    }
    this.branch[i].selected = !this.branch[i].selected;
    this.changeFilter('branch');
    console.log('branch selected => ', this.branch_selected);
  }

  public branchClickAll(){
    // if(this.sbu_user || this.branch_user || this.custom_user && !this.userApi.akses.lihat_project_user_data.all_branch){
    //   return;
    // }
    if(this.branch_user){
      return;
    }
    this.branch_all_selected = !this.branch_all_selected;
    this.branch.forEach(rec => {
      rec.selected = this.branch_all_selected;
    });
    this.changeFilter('branch');
  }

  public sbuClick(i){
    if(this.sbu_user){
      return;
    }
    this.sbu[i].selected = !this.sbu[i].selected;
    this.changeFilter('sbu');
  }

  public sbuClickAll(){
    if(this.sbu_user){
      return;
    }
    this.sbu_all_selected = !this.sbu_all_selected;
    this.sbu.forEach(rec => {
      rec.selected = this.sbu_all_selected;
    });
    this.changeFilter('sbu');
  }

  public statusClick(i){
    this.status[i].selected = !this.status[i].selected;
    this.changeFilter('status');
  }
 
  public changeFilter(opt=''){
    if(opt=='sbu' || opt==''){
      let all = 0;
      if(this.sbu_user || this.custom_user && !this.userApi.akses.lihat_project_user_data.all_sbu){
        all = 0;
      }else{
        all = 1;
      }
      this.sbu_selected = [];
      this.sbu.forEach(rec => {
        if(rec.selected){
          this.sbu_selected.push(rec.id);
        }else{
          all = 0;
        }
      });
      this.sbu_all_selected = all;
    } 

    if(opt=='branch'  || opt==''){
      let all = 0;
      if(this.branch_user || this.custom_user && !this.userApi.akses.lihat_project_user_data.all_branch){
        all = 0;
      }else{
        all = 1;
      }
      
      this.branch_selected = [];
      this.branch.forEach(rec => {
        if(rec.selected){
          this.branch_selected.push(rec.id);
        }else{
           all = 0
        }
      });
      this.branch_all_selected = all;
    }

    if(opt=='company'  || opt==''){
      let all = 1;
      this.company_selected = [];
      this.company.forEach(rec => {
        if(rec.selected){
          this.company_selected.push(rec.id);
        }else{
          all = 0;
        }
      });
      this.company_all_selected = all;
    }

    if(opt=='status'  || opt==''){
      let all = 1;
      this.status_selected = [];
      this.status.forEach(rec => {
        if(rec.selected){
          this.status_selected.push(rec.code);
        }else{
          all = 0;
        }
      });
      this.status_all_selected = all;
    }

    this.filterBar();
    this.filterDepartment();
    //this.filterPie();
  }

  // events
  public chartClicked(e:any):void {
    // if (e.active.length > 0) {
    //   var chartElement = e.active[0]._chart.getElementAtEvent(event);
    //   let select = chartElement[0]._model;
    // }
  }

  toListProject(dept_id='',branch_id='') {
    let params:any = {};
    if(dept_id!=''){
      params.dept_id = dept_id;
    }
    if(branch_id!=''){
      params.branch_id = branch_id;
    }
    params.all_sbu = this.sbu_all_selected;
    params.all_company = this.company_all_selected;
    params.all_branch = this.branch_all_selected;

    params.company_ids = this.company_selected.join(',');
    params.branch_ids  = this.branch_selected.join(',');
    params.sbu_ids     = this.sbu_selected.join(',');
    params.status_ids  = this.status_selected.join(',');
    this.navCtrl.push(ListProjectPage,{
      params : params
    });
  }


  confirmLogout() {
    const confirm = this.alertCtrl.create({
      title: 'Yakin akan keluar ?',
      buttons: [
        {
          text: 'Tidak',
          handler: () => {

          }
        },
        {
          text: 'Ya',
          handler: () => {
            this.logout();
          }
        }
      ]
    });
    confirm.present();
  }

  logout(){
    localStorage.clear();
    this.navCtrl.push(LoginPage);
  }

  toProfile(){
    this.navCtrl.push(ProfilePage);
  }

 
}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/dashboard/page.ts